var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 1)"},React.createElement("line",{"x2":"8.889","transform":"translate(0)","fill":"none","stroke":"#fff","strokeWidth":"2"})));
}

Minus.defaultProps = {"width":"8.889","height":"2","viewBox":"0 0 8.889 2"};

module.exports = Minus;

Minus.default = Minus;
